import { string, object } from 'yup';

const schema = object({
  question: string().required('Question is required'),
  locationType: string().required('Location type is required'),
  questionType: string().required('Question type is required')
});

export default { create: schema, edit: schema };
